// Shared logic with server and client
import { createSSRApp, createApp } from 'vue'
import { createHead as createClientHead } from '@unhead/vue/client'
import { createHead as createServerHead } from '@unhead/vue/server'
import I18NextVue from 'i18next-vue'
import VueGtm from '@gtm-support/vue-gtm'

import App from './App.vue'
import i18next from './i18n/index.js'
import { isSSR } from './utils/index.js'

import getRouter from './router/index.js'
import getStore from './store/index.js'

export const buildApp = (envVar = null) => {
  const store = getStore()
  const router = getRouter(store)
  const app = (isSSR() ? createSSRApp : createApp)(App)

  if (envVar && envVar.gtmId) {
    if (!isSSR()) {
      window.dataLayer = window.dataLayer || []
      window.dataLayer.push(envVar.gtmDataLayer)
    }
    app.use(VueGtm, {
      id: envVar.gtmId,
      debug: envVar.gtmDebug === 'true',
      loadScript: true,
      vueRouter: router
    })
  }

  const head = isSSR() ? createServerHead() : createClientHead()
  app.use(router)
  app.use(store)
  app.use(head)
  app.use(I18NextVue, { i18next })

  return { app, head, store, router }
}
